import React, { useEffect, useState, useCallback } from 'react';
import { Message, Icon, Transition } from 'semantic-ui-react';
import './NotificationPopup.css';

const NotificationPopup = ({
  message,
  type = 'info',
  header,
  onClose,
  duration = 5000,
  visible = false
}) => {
  const [isVisible, setIsVisible] = useState(visible);

  const handleClose = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300); // Wait for animation to complete
  }, [onClose]);

  useEffect(() => {
    setIsVisible(visible);

    if (visible && duration && duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [visible, duration, handleClose]);

  // Determine icon and color based on type
  const getIconAndColor = () => {
    switch (type) {
      case 'success':
        return { icon: 'check circle', color: 'green' };
      case 'error':
        return { icon: 'exclamation circle', color: 'red' };
      case 'warning':
        return { icon: 'exclamation triangle', color: 'yellow' };
      default:
        return { icon: 'info circle', color: 'blue' };
    }
  };

  const { icon, color } = getIconAndColor();

  if (!message) return null;

  return (
    <Transition
      visible={isVisible}
      animation='slide left'
      duration={300}
    >
      <div className="notification-popup-container">
        <Message
          className="notification-popup"
          color={color}
          onDismiss={handleClose}
          size="large"
        >
          <Icon name={icon} />
          <Message.Content>
            {header && <Message.Header>{header}</Message.Header>}
            <p>{message}</p>
          </Message.Content>
        </Message>
      </div>
    </Transition>
  );
};

export default NotificationPopup;
